/* Menu Beta panels: <details> gives click/tap toggling for free; this adds
   desktop hover-intent (open on enter, close on leave with a short grace
   delay), one-panel-at-a-time, and close on Esc or outside click. */
class EscMenuBeta extends HTMLElement {
  connectedCallback() {
    this.groups = Array.from(this.querySelectorAll('details'));
    this.hoverMedia = window.matchMedia('(hover: hover) and (min-width: 750px)');

    /* Below 750px the whole bar folds behind one labelled row. Only the
       attribute is flipped here — the CSS decides whether that means anything,
       so nothing has to be undone when the viewport grows past the breakpoint
       and the list becomes visible again on its own. */
    this.list = this.querySelector('.esc-menu-beta__list');
    this.collapseToggle = this.querySelector('.esc-menu-beta__collapse-toggle');
    if (this.collapseToggle) {
      this.collapseToggle.addEventListener('click', () => {
        this.setCollapsed(this.collapseToggle.getAttribute('aria-expanded') === 'true');
      });
    }

    this.groups.forEach((group) => {
      const summary = group.querySelector('summary');

      group.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', group.open);
        if (group.open) this.closeOthers(group);
      });

      group.addEventListener('mouseenter', () => {
        if (!this.hoverMedia.matches) return;
        clearTimeout(this.closeTimer);
        this.closeOthers(group);
        group.open = true;
      });

      group.addEventListener('mouseleave', () => {
        if (!this.hoverMedia.matches) return;
        this.closeTimer = setTimeout(() => {
          group.open = false;
        }, 180);
      });

      summary.addEventListener('click', (event) => {
        // On hover-capable desktop pointers, moving onto the summary already
        // fires mouseenter (above) and opens the panel before the click even
        // lands. Without this guard, the browser's native summary-click
        // toggle then immediately closes the panel that hover just opened,
        // which is why the dropdown content appeared not to show at all.
        // Hover fully owns open/close on those pointers, so we swallow the
        // click there; keyboard activation (detail === 0) and touch/narrow
        // viewports (hoverMedia doesn't match) still toggle normally.
        if (this.hoverMedia.matches && event.detail !== 0) {
          event.preventDefault();
        }
      });
    });

    /* setCollapsed closes the panels on the way, so these cover both layers:
       tapping the page or pressing Esc folds the bar back to one row. */
    document.addEventListener('click', (event) => {
      if (!this.owns(event.target)) this.setCollapsed(true);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.setCollapsed(true);
    });
  }

  /* Below 750px esc-mobile-nav.js moves this list into Menu Alpha's panel, so
     the list is no longer a descendant of this element and `contains` alone
     would report every tap on our own submenus as an outside click — closing
     the panel the tap just opened. Ask the list too, wherever it currently
     lives. */
  owns(node) {
    if (this.contains(node)) return true;
    return this.list ? this.list.contains(node) : false;
  }

  setCollapsed(collapsed) {
    if (collapsed) this.closeAll();
    if (!this.collapseToggle) return;
    this.collapseToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  }

  closeOthers(current) {
    this.groups.forEach((group) => {
      if (group !== current) group.open = false;
    });
  }

  closeAll() {
    this.groups.forEach((group) => {
      group.open = false;
    });
  }
}

if (!customElements.get('esc-menu-beta')) {
  customElements.define('esc-menu-beta', EscMenuBeta);
}
